import { Home , Anchor,  Airplay, BatteryCharging, Box,  DollarSign, FolderPlus, Command, Cloud, BarChart, Download, Users, ShoppingBag, Phone, List, Mail, MessageCircle, GitPullRequest, Monitor,Heart, Clock,Zap,CheckSquare, Calendar, Image,HelpCircle,Radio,Map,Edit, Sunrise,Package,Sliders,Layout,Server,Database,Search,File,Layers,UserCheck,Wifi, CreditCard,Settings, FileText} from "react-feather";

import { LuUser } from "react-icons/lu";
import { BsEvStation } from "react-icons/bs";
import { FaChargingStation } from "react-icons/fa6";
import { GrTransaction } from "react-icons/gr";

import evtorlogo from "../../assets/images/evtorlogo.jpg"
import { code } from "../../api/DataApis";
// import evtorlogo from "../../../public/evtorlogo.png";

export const MENUITEMS = [
{
    menutitle: "General",
    menucontent:
      "Dashboards, Widgets, Enquire, Masters, Users, Stations, Chargers, Ocpp, RFID, Transactions",
    Items: [
      {
       path: `${process.env.PUBLIC_URL}/dashboard/default`,
        title: "Dashboard",
        icon: Home,
        type: "link",
      },
//masters   
{

  title: "My Orders",
  icon: Settings,
  type: "sub",
  active: false,
  children: [
    {
      path: `/order-list`,
      title: "My Orders",
      icon: Users,
      type: "link",
    },
  ],

  
},
{

  title: "Settings",
  icon: Box,
  type: "sub",
  active: false,
  children: [
    {
      path: `/permission-page`,
      title: "Permissions",
      icon: Users,
      type: "link",
    },
  ],

  
}
],
  },
];
